/**
 * Module AppRegistry - Quản lý danh mục ứng dụng tập trung của Workspace
 * Đăng ký 5 ứng dụng ngụy trang hiện có trong hệ thống và cho phép mở rộng không giới hạn
 */

/**
 * Danh sách 6 ứng dụng ngụy trang mặc định của Workspace
 */
export const DEFAULT_WORKSPACE_APPS = [
  {
    id: 'sheets',
    name: 'Google Sheets',
    description: 'Bảng tính trực tuyến & Quản lý dữ liệu kế toán',
    category: 'productivity',
    route: '#/sheets',
    enabled: true,
    order: 1,
    disguiseDocType: 'xlsx',
    badgeText: 'Phổ biến',
    // SVG icon Google Sheets chuẩn màu xanh lá
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><path fill="#0F9D58" d="M26.5 4H10A3 3 0 0 0 7 7v26a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3V12.5L26.5 4z"/><path fill="#87CEAC" d="M25 4v9h9"/><rect fill="#FFFFFF" x="12" y="17" width="16" height="3" rx="0.5"/><rect fill="#FFFFFF" x="12" y="23" width="16" height="3" rx="0.5"/><rect fill="#FFFFFF" x="12" y="29" width="11" height="3" rx="0.5"/></svg>`,
    themeColor: '#0F9D58'
  },
  {
    id: 'email',
    name: 'Gmail Web',
    description: 'Hộp thư điện tử nội bộ & Trao đổi công việc',
    category: 'communication',
    route: '#/email',
    enabled: true,
    order: 2,
    disguiseDocType: 'mail',
    badgeText: '',
    // SVG icon Gmail chuẩn màu đỏ Google
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><path fill="#4285F4" d="M32 9H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4z"/><path fill="#EA4335" d="M32 9L20 18 8 9a4 4 0 0 0-4 4v1l16 11 16-11v-1a4 4 0 0 0-4-4z"/><path fill="#FBBC05" d="M4 13v15a4 4 0 0 0 4 4h2V18L4 13z"/><path fill="#34A853" d="M36 13l-6 5v14h2a4 4 0 0 0 4-4V13z"/></svg>`,
    themeColor: '#EA4335'
  },
  {
    id: 'zalo',
    name: 'Zalo Chat',
    description: 'Tin nhắn trao đổi công việc & Thảo luận dự án',
    category: 'communication',
    route: '#/zalo',
    enabled: true,
    order: 3,
    disguiseDocType: 'msg',
    badgeText: '',
    // SVG icon Zalo chuẩn màu xanh dương
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><rect width="36" height="36" rx="8" fill="#0068FF" x="2" y="2"/><path fill="#FFFFFF" d="M12 14h16c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H18l-5 4v-4h-1c-1.1 0-2-.9-2-2v-9c0-1.1.9-2 2-2z"/><circle fill="#0068FF" cx="16" cy="20.5" r="1.5"/><circle fill="#0068FF" cx="20" cy="20.5" r="1.5"/><circle fill="#0068FF" cx="24" cy="20.5" r="1.5"/></svg>`,
    themeColor: '#0068FF'
  },
  {
    id: 'canva',
    name: 'Canva Design',
    description: 'Thiết kế slide thuyết trình & Đồ họa trực quan',
    category: 'creative',
    route: '#/canva',
    enabled: true,
    order: 4,
    disguiseDocType: 'design',
    badgeText: 'Mới',
    // SVG icon Canva chuẩn gradient tím ngọc
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><rect width="36" height="36" rx="8" fill="url(#cv-grad)" x="2" y="2"/><defs><linearGradient id="cv-grad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#00C4CC"/><stop offset="100%" stop-color="#7D2AE8"/></linearGradient></defs><path fill="#FFFFFF" d="M20 10c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm4.5 14.5c-.8.8-2 1.3-3.5 1.3-3 0-5-2.2-5-5.3 0-3.3 2.2-5.5 5.2-5.5 1.4 0 2.5.5 3.3 1.2l-1.2 1.5c-.6-.5-1.3-.8-2.1-.8-1.8 0-3.2 1.4-3.2 3.6 0 2 1.2 3.5 3.1 3.5.9 0 1.6-.3 2.1-.7l1.3 1.2z"/></svg>`,
    themeColor: '#7D2AE8'
  },
  {
    id: 'capcut',
    name: 'CapCut Studio',
    description: 'Trình biên tập video đa phương tiện & Dựng phim',
    category: 'media',
    route: '#/capcut',
    enabled: true,
    order: 5,
    disguiseDocType: 'mp4',
    badgeText: '',
    // SVG icon CapCut chuẩn màu đen viền xanh neon
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><rect width="36" height="36" rx="8" fill="#18181c" x="2" y="2"/><path fill="#00D26A" d="M12 12l8 8-8 8v-4l4-4-4-4v-4zm16 0v4l-4 4 4 4v4l-8-8 8-8z"/></svg>`,
    themeColor: '#00D26A'
  },
  {
    id: 'calendar',
    name: 'Calendar Caro',
    description: 'Lịch hẹn, phòng Caro online & chơi cùng bạn bè',
    category: 'games',
    route: '#/calendar',
    enabled: true,
    order: 6,
    disguiseDocType: 'calendar',
    badgeText: 'Mới',
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><rect x="4" y="6" width="32" height="30" rx="6" fill="#5b6edb"/><path d="M4 13h32" stroke="#fff" stroke-width="3"/><path d="M12 4v6M28 4v6" stroke="#394bb8" stroke-width="3" stroke-linecap="round"/><path d="M13 21l4 4 9-9" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    themeColor: '#5B6EDB'
  },
  {
    id: 'emulator',
    name: 'Android Studio',
    description: 'Giả lập di động Pixel 8 Pro, kiểm thử ứng dụng & Shorts',
    category: 'developer',
    route: '#/emulator',
    enabled: true,
    order: 7,
    disguiseDocType: 'apk',
    badgeText: 'Mới',
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><rect width="36" height="36" rx="8" fill="#073042" x="2" y="2"/><path fill="#3DDC84" d="M12 24c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V25h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V25h1c.55 0 1-.45 1-1V14h-8v10zm-2.5-10c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-4.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C21.85 8.23 20.95 8 20 8c-.96 0-1.86.23-2.66.63L15.85 7.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.3C14.73 10.15 13.5 11.92 13.5 14h13c0-2.08-1.23-3.85-2.97-4.84zM18 11.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75zm4 0c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75z"/></svg>`,
    themeColor: '#3DDC84'
  },
  {
    id: 'figma',
    name: 'Figma Prototype',
    description: 'Thiết kế giao diện UI/UX Artboard iPhone 15 Pro & Shorts',
    category: 'creative',
    route: '#/figma',
    enabled: true,
    order: 8,
    disguiseDocType: 'fig',
    badgeText: 'Mới',
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><rect width="36" height="36" rx="8" fill="#1e1e1e" x="2" y="2"/><g transform="translate(13, 8) scale(0.7)"><path d="M10 15a5 5 0 1 1 10 0 5 5 0 0 1-10 0z" fill="#1ABCFE"/><path d="M0 25a5 5 0 0 1 5-5h5v5a5 5 0 1 1-10 0z" fill="#0ACF83"/><path d="M10 0v10h5a5 5 0 1 0 0-10h-5z" fill="#FF7262"/><path d="M0 5a5 5 0 0 0 5 5h5V0H5a5 5 0 0 0-5 5z" fill="#F24E1E"/><path d="M0 15a5 5 0 0 0 5 5h5V10H5a5 5 0 0 0-5 5z" fill="#A259FF"/></g></svg>`,
    themeColor: '#A259FF'
  },
  {
    id: 'vscode',
    name: 'VS Code IDE',
    description: 'Môi trường phát triển Angular, TypeScript & Tài liệu kỹ thuật',
    category: 'developer',
    route: '#/vscode',
    enabled: true,
    order: 9,
    disguiseDocType: 'ts',
    badgeText: 'Mới',
    iconSvg: `<svg viewBox="0 0 40 40" width="36" height="36"><rect width="36" height="36" rx="8" fill="#1e1e1e" x="2" y="2"/><path fill="#007ACC" d="M28.5 7.5L21.2 14.2 14.5 9 10 11.8v16.4l4.5 2.8 6.7-5.2 7.3 6.7 4.5-2.2V9.7L28.5 7.5zm0 18.2L20.2 20l8.3-5.7v11.4zM13 22.8v-5.6l4 2.8-4 2.8z"/></svg>`,
    themeColor: '#007ACC'
  }
];

export class AppRegistry {
  /**
   * Khởi tạo Registry với danh sách ứng dụng mặc định
   * @param {Array<Object>} [customApps] Danh sách ứng dụng bổ sung nếu có
   */
  constructor(customApps = []) {
    // 1. Khởi tạo danh sách ứng dụng, ghép nối và kiểm tra hợp lệ
    this.apps = new Map();

    const initialList = [...DEFAULT_WORKSPACE_APPS, ...(Array.isArray(customApps) ? customApps : [])];
    initialList.forEach(app => {
      if (app && app.id) {
        this.apps.set(app.id, app);
      }
    });
  }

  /**
   * Đăng ký thêm một ứng dụng mới vào Workspace (khả năng mở rộng)
   * @param {Object} app Cấu hình ứng dụng
   * @returns {boolean} true nếu đăng ký thành công
   */
  registerApp(app) {
    if (!app || typeof app !== 'object' || !app.id || typeof app.id !== 'string') {
      console.warn('[AppRegistry] Không thể đăng ký ứng dụng do thiếu định danh id');
      return false;
    }

    const cleanId = app.id.trim();
    if (this.apps.has(cleanId)) {
      console.warn(`[AppRegistry] Ứng dụng "${cleanId}" đã tồn tại, đang ghi đè cấu hình...`);
    }

    const cleanApp = {
      id: cleanId,
      name: app.name || cleanId,
      description: app.description || '',
      category: app.category || 'productivity',
      route: app.route || `#/${cleanId}`,
      enabled: app.enabled !== false,
      order: typeof app.order === 'number' ? app.order : 99,
      disguiseDocType: app.disguiseDocType || 'doc',
      iconSvg: app.iconSvg || '',
      themeColor: app.themeColor || '#1a73e8'
    };

    this.apps.set(cleanId, cleanApp);
    return true;
  }

  /**
   * Lấy thông tin ứng dụng theo mã ID
   * @param {string} id Mã ứng dụng trong Workspace
   * @returns {Object|null}
   */
  getAppById(id) {
    if (!id || typeof id !== 'string') return null;
    return this.apps.get(id.trim()) || null;
  }

  /**
   * Lấy toàn bộ danh sách ứng dụng đã bật (sắp xếp theo thứ tự order tăng dần)
   * @returns {Array<Object>}
   */
  getEnabledApps() {
    return Array.from(this.apps.values())
      .filter(app => Boolean(app.enabled))
      .sort((a, b) => (a.order || 0) - (b.order || 0));
  }

  /**
   * Lấy danh sách ứng dụng theo nhóm phân loại (category)
   * @param {string} category 
   * @returns {Array<Object>}
   */
  getAppsByCategory(category) {
    if (!category || typeof category !== 'string') return [];
    return this.getEnabledApps().filter(app => app.category === category);
  }
}

// Xuất ra một instance duy nhất (Singleton Pattern) để dùng chung toàn hệ thống
export const appRegistry = new AppRegistry();
